<template>
	<div v-loading.fullscreen.lock="fullscreenLoading">
		<TopHeader :tabIndex='2'></TopHeader>
		<div class="cont">
			<div class="flex flex-b">
				<div class="title">培训中心</div>
				<div class="search flex">
					<img src="../../assets/icon/search.png" style="width: 16px;height: 16px;" alt="" />
					<input type="text" v-model="keyword" placeholder="搜索课程" @keyup.enter="getTrainList()">
				</div>
			</div>
			<div class="flex-only" style="margin-top: 30px;">
				<div class="tit">一级分类</div>
				<div class="flex flex-1 flex-wrap">
					<div class="item pointer" :class="tabIndex1==0?'active':''" @click="changeType(0)">全部</div>
					<div class="item pointer" v-for="(item,index) in trainCateList"
						:class="tabIndex1==index+1?'active':''" @click="changeType(item,index)">{{item.name}}</div>
				</div>
			</div>
			<div class="flex-only" style="margin-top: 10px;">
				<div class="tit">二级分类</div>
				<div class="flex flex-1 flex-wrap">
					<div class="item pointer" :class="tabIndex2==0?'active':''" @click="changeStatus(0)">全部</div>
					<div class="item pointer" v-for="(item,index) in statusList" :class="tabIndex2==index+1?'active':''"
						@click="changeStatus(item,index)">{{item}}</div>
				</div>
			</div>

			<div class="result">共找到 <span>{{count}}</span> 门课程</div>

			<div class="flex flex-wrap">
				<div class="itembg1 pointer" v-for="(item,i) in trainList" @click="toTarinDetail(item)">
					<div class="rel">
						<img :src="item.img" style="width: 100%;height: 205px;border-radius: 13px;" />
						<div class="status" v-if="item.status==1">报名中</div>
						<div class="status status2" v-if="item.status==2">进行中</div>
						<div class="status status3" v-if="item.status==3">已结束</div>
						<div class="tip">{{item.train_cate_name}}</div>
					</div>
					<div class="ititle">{{item.name}}</div>
					<div class="flex mt10">
						<img src="../../assets/images/icon/irl.png" style="width: 13px;height: 13px;" />
						<div class="time">{{item.begin_time}}至 {{item.end_time}}</div>
					</div>
					<div class="flex mt10">
						<img src="../../assets/images/icon/idz.png" style="width: 13px;height: 13px;" />
						<div class="time">{{item.address}}</div>
					</div>
					<div class="flex flex-b" style="margin-top: 10px;">
						<div class="price flex" v-if="item.pay_type==1">{{item.score}}积分</div>
						<div class="price flex" v-if="item.pay_type==2">¥{{item.price}}</div>
						<div class="price flex" v-if="item.pay_type==3">免费培训</div>
						<div class="moreBtn flex flex-c-c flex-c pointer" v-if="item.is_order!=1">
							<div class="tex" v-if="item.status==1">立即报名</div>
							<div class="tex" v-else>查看详情</div>
							<img src="../../assets/images/home/rightGreen.png"
								style="width: 7px;height: 9px;margin-left: 7px;">
						</div>
						<div class="moreBtn flex flex-c-c flex-c pointer" v-else>
							<div class="tex">查看详情</div>
						</div>
					</div>

				</div>
			</div>

			<pagination :total='count' :page_size='page_size' @currentChange='currentChange'></pagination>
		</div>
		<div class="toTop" v-if="showBackToTop" @click="scrollToTop"></div>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getTrainCate,
		getTrainList
	} from "@/api/train";
	import TopHeader from "../../components/TopHeader.vue";
	import Footer from "../../components/Footer.vue";
	import Pagination from "../../components/Pagination.vue";

	export default {
		data() {
			return {
				tabIndex1: 0,
				tabIndex2: 0,
				statusList: ['报名中', '进行中', '已结束'],
				showBackToTop: false,
				trainCateList: [],
				id: '',
				keyword: '',
				trainList: [],
				page_size: 9,
				page_index: 1,
				count: 0,
				fullscreenLoading:true
			}
		},
		components: {
			TopHeader,
			Footer,
			Pagination
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			this.getTrainCate()
			this.getTrainList()
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			toTarinDetail(item) {
				this.$router.push({
					path: '/trainingDetail',
					query: {
						id: item.uuid,
					}
				})
			},
			changeType(item, index) {
				if (item == 0) {
					this.tabIndex1 = 0
					this.id = ''
					this.getTrainList()
					return
				}
				this.tabIndex1 = index + 1
				this.id = item.uuid
				this.getTrainList()
			},
			changeStatus(item, index) {
				if (item == 0) {
					this.tabIndex2 = 0
					this.id = ''
					this.getTrainList()
					return
				}
				this.tabIndex2 = index + 1
				this.getTrainList()
			},
			async getTrainCate() {
				const {
					status,
					data
				} = await getTrainCate({})
				this.trainCateList = data.result
			},
			async getTrainList() {
				const {
					status,
					data
				} = await getTrainList({
					train_cate_uuid: this.id,
					status: this.tabIndex2,
					keyword: this.keyword,
					page_index: this.page_index,
					page_size: this.page_size
				})
				this.trainList = data.result.data
				this.count = data.result.total
				this.fullscreenLoading = false
			},
			//改变页数
			currentChange(e) {
				this.page_index = e
				this.getTrainList()
			},
			handleScroll() {
				// 当滚动到距离底部100px时显示按钮（可根据需求调整）
				const scrollY = window.scrollY
				const visibleHeight = document.documentElement.clientHeight
				const pageHeight = document.documentElement.scrollHeight
				this.showBackToTop = (scrollY + visibleHeight) > (pageHeight + 1000)
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.toTop {
		position: fixed;
		right: 190px;
		bottom: 143px;
		background: url('../../assets/images/home/top.png') no-repeat;
		width: 53px;
		height: 53px;
		z-index: 9999;
		background-size: 100% 100%;
		cursor: pointer;
	}

	.cont {
		padding: 60px 133px 0;

		.title {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 27px;
			color: #000000;
		}

		.search {
			height: 40px;
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			input {
				margin-left: 10px;
				border: none;
				background-color: transparent;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333;

				&:focus {
					outline: none;
				}
			}
		}

		.tit {
			width: 7%;
			line-height: 36px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
		}

		.item {
			margin: 0 20px 14px 0;
			height: 36px;
			padding: 0 14px;
			background: #FFFFFF;
			border-radius: 9px 9px 9px 9px;
			border: 1px solid #EEEEEE;
			opacity: 0.8;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
			line-height: 36px;
		}

		.active {
			height: 36px;
			border: 1px solid rgba(0, 167, 60, 0.06);
			background: rgba(0, 167, 60, 0.06);
			border-radius: 9px 9px 9px 9px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 16px;
			color: #00A73C;
			line-height: 36px;
		}

		.result {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			color: #000000;
			line-height: 60px;

			span {
				color: #00A73C;
			}
		}

		.itembg1 {
			width: calc(33% - 27px);
			margin-right: 27px;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			background: #FFFFFF;
			border-radius: 13px 13px 13px 13px;
			padding: 9px 11px;
			position: relative;
			margin-bottom: 20px;

			&:nth-child(3n) {
				margin-right: 0;
			}

			.rel {
				position: relative;
				border-radius: 13px;
				overflow: hidden;

				.status {
					position: absolute;
					right: 0;
					top: 0;
					height: 22px;
					background: #00A73C;
					border-radius: 0px 13px 0px 9px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FFFFFF;
					line-height: 22px;
					padding: 0 10px;

					&.status2 {
						background: #D7B155;
					}

					&.status3 {
						background: #FC5F5F;
					}
				}

				.tip {
					position: absolute;
					left: 10px;
					bottom: 10px;
					height: 22px;
					line-height: 22px;
					padding: 0 10px;
					background: rgba(0, 0, 0, 0.4);
					border-radius: 4px 4px 4px 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FFFFFF;
				}
			}

			.ititle {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
				margin-top: 13px;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
			}

			.mt10 {
				margin-top: 10px;
			}

			.time {
				margin-left: 10px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
			}

			.price {
				font-family: DINPro, DINPro;
				font-weight: bold;
				font-size: 22px;
				color: #00A73C;
			}

			.moreBtn {
				margin-right: 10px;
				background: url('../../assets/images/course/btn109.png') no-repeat;
				width: 109px;
				height: 49px;
				background-size: 100% 100%;

				.tex {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
					background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}
		}
	}
</style>